<div class="voice-catalog">
  @if (!botId) {
    <p class="text-secondary">{{ 'BOTS.voiceCatalogSaveFirst' | translate }}</p>
  } @else if (loading) {
    <div class="flex items-center gap-2">
      <mat-spinner diameter="20"></mat-spinner>
      <span class="text-secondary">{{ 'BOTS.voiceCatalogLoading' | translate }}</span>
    </div>
  } @else if (!voices.length) {
    <p class="text-secondary">{{ 'BOTS.voiceCatalogUnavailable' | translate }}</p>
  } @else {
    @if (premiumVoices.length) {
      <h4 class="font-medium mb-2">{{ 'BOTS.voiceCatalogPremiumTier' | translate }}</h4>
      <div class="flex flex-col gap-2 mb-4">
        <ng-container *ngTemplateOutlet="voiceRow; context: { $implicit: premiumVoices }"></ng-container>
      </div>
    }

    @if (budgetVoices.length) {
      <h4 class="font-medium mb-2">{{ 'BOTS.voiceCatalogBudgetTier' | translate }}</h4>
      <div class="flex flex-col gap-2">
        <ng-container *ngTemplateOutlet="voiceRow; context: { $implicit: budgetVoices }"></ng-container>
      </div>
    }
  }

  <audio #voiceAudioPlayer style="display: none"></audio>
</div>

<ng-template #voiceRow let-tierVoices>
  @for (voice of tierVoices; track voice.key) {
    <div
      class="voice-catalog-row flex items-center justify-between gap-3 rounded-lg border border-border p-3"
      [class.opacity-50]="!voice.available || !languageChoicesFor(voice).length"
    >
      <div class="flex min-w-0 flex-1 flex-col">
        <div class="flex items-center gap-2">
          <span class="font-medium">{{ voice.name }}</span>
          @if (isSelected(voice)) {
            <span class="voice-catalog-selected-badge flex items-center gap-1 text-xs text-primary">
              <mat-icon class="icon-size-4" inline>check_circle</mat-icon>
              {{ 'BOTS.voiceCatalogSelected' | translate }}
            </span>
          }
        </div>
        <span class="text-sm text-secondary">{{ voice.blurb }}</span>
        @if (voice.available && !languageChoicesFor(voice).length) {
          <span class="text-xs text-secondary mt-1">{{ 'BOTS.voiceCatalogNoCompatibleLanguage' | translate }}</span>
        }
        @if (!voice.available) {
          <span class="text-xs text-secondary mt-1">{{ 'BOTS.voiceCatalogNoCredentials' | translate }}</span>
        }
      </div>
      <div class="flex shrink-0 items-center gap-2">
        @if (voice.available && languageChoicesFor(voice).length > 1) {
          <mat-select
            class="voice-catalog-lang-select"
            [aria-label]="'Audition language for ' + voice.name"
            [ngModel]="selectedLanguage[voice.key]"
            (ngModelChange)="onLanguageChange(voice.key, $event)"
          >
            @for (choice of languageChoicesFor(voice); track choice.value) {
              <mat-option [value]="choice.value">
                {{ choice.value }}{{ choice.experimental ? ' (' + ('BOTS.voiceCatalogExperimental' | translate) + ')' : '' }}
              </mat-option>
            }
          </mat-select>
        } @else if (voice.available && languageChoicesFor(voice).length === 1) {
          <span class="voice-catalog-lang-static">
            {{ languageChoicesFor(voice)[0].value
            }}{{
              languageChoicesFor(voice)[0].experimental ? ' (' + ('BOTS.voiceCatalogExperimental' | translate) + ')' : ''
            }}
          </span>
        }
        <button
          mat-icon-button
          [disabled]="!voice.available || !languageChoicesFor(voice).length || auditioningKey === voice.key"
          (click)="audition(voice)"
          [attr.aria-label]="'Play ' + voice.name"
        >
          @if (auditioningKey === voice.key) {
            <mat-spinner diameter="20"></mat-spinner>
          } @else if (playingKey === voice.key) {
            <mat-icon>volume_up</mat-icon>
          } @else {
            <mat-icon>play_arrow</mat-icon>
          }
        </button>
        <button
          class="voice-catalog-select-btn"
          mat-stroked-button
          color="primary"
          [disabled]="
            !voice.available || !languageChoicesFor(voice).length || selectingKey === voice.key || isSelected(voice)
          "
          (click)="select(voice)"
        >
          @if (selectingKey === voice.key) {
            <mat-spinner diameter="16"></mat-spinner>
          } @else if (isSelected(voice)) {
            {{ 'BOTS.voiceCatalogSelected' | translate }}
          } @else {
            {{ 'BOTS.voiceCatalogSelect' | translate }}
          }
        </button>
      </div>
    </div>
  }
</ng-template>
